/**
 * Catalog autoload: автоматическая подгрузка следующей страницы списка
 * товаров при скролле (specs/006-catalog-scroll-load).
 *
 * Не дублирует ajax-логику: при приближении кнопки «Показать еще»
 * (.ajax_load_btn) к вьюпорту программно кликает по ней — срабатывает
 * существующий обработчик из js/main.js со всеми POST-параметрами
 * (shown_product_lines, wide_grid_offset) и post-init цепочкой.
 *
 * Кнопка заменяется вместе с .bottom_nav после каждой подгрузки, поэтому
 * наблюдатель перенацеливается на новый элемент по событию onAjaxSuccess.
 * На последней странице кнопка не рендерится — наблюдение прекращается.
 * При ошибке ajax повтор только ручным кликом (автотриггер не зацикливается).
 */
export function initCatalogAutoload() {
  if (typeof IntersectionObserver === 'undefined') {
    return;
  }

  const BTN_SELECTOR = '.ajax_load_btn';
  const LOADING_SELECTOR = '.more_text_ajax.loading';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }
        const btn = entry.target;
        // Не триггерим, пока идёт загрузка (защита от параллельных запросов
        // есть и в обработчике main.js — здесь не даём лишний раз кликнуть).
        if (btn.querySelector(LOADING_SELECTOR)) {
          return;
        }
        // Снимаем наблюдение до клика: после успеха придёт onAjaxSuccess и
        // перенацелит на новую кнопку; после ошибки повтор — только ручной.
        observer.unobserve(btn);
        btn.click();
      });
    },
    {
      root: null,
      // Триггер примерно за экран до появления кнопки на экране.
      rootMargin: '0px 0px 100% 0px',
      threshold: 0,
    }
  );

  const arm = () => {
    document.querySelectorAll(BTN_SELECTOR).forEach((btn) => {
      observer.observe(btn);
    });
  };

  arm();

  // .bottom_nav (и кнопка в нём) заменяется после каждой подгрузки —
  // перенацеливаемся на свежую кнопку; если её нет, arm() просто ничего
  // не найдёт (конец списка).
  //
  // Перенацеливание отложено: в main.js после onAjaxSuccess пагинация
  // перезаписывается ЕЩЁ раз (второй апдейт .bottom_nav, ~main.js:4718),
  // поэтому наблюдать надо финальный элемент, а не тот, что был в DOM
  // в момент события.
  const rearm = () => setTimeout(arm, 0);

  if (typeof BX !== 'undefined' && typeof BX.addCustomEvent === 'function') {
    BX.addCustomEvent('onAjaxSuccess', rearm);
    // Ветка не-каталожных списков (новости/блог) в main.js стреляет
    // onCompleteAction вместо onAjaxSuccess.
    BX.addCustomEvent('onCompleteAction', rearm);
  }
}
